import { FinancialJuiceWidget } from './FinancialJuiceWidget';

interface FJHeadlinesWidgetProps {
  onRemove: () => void;
}

export function FJHeadlinesWidget({ onRemove }: FJHeadlinesWidgetProps) {
  return (
    <FinancialJuiceWidget
      widgetType="NEWS"
      mode="dark"
      title="Headlines"
      onRemove={onRemove}
    />
  );
}
